import type { WorkflowHistoryUrlState } from "./workflow-history-url-state.ts";

export type WorkflowRunsQueryFilters = Pick<WorkflowHistoryUrlState, "workflow" | "status" | "period" | "from" | "to"> & {
  source: string;
  limit: number;
};

export function workflowRunsQueryKey(filters: WorkflowRunsQueryFilters) {
  return [
    "workflows",
    "runs",
    filters.source,
    filters.workflow,
    filters.status,
    filters.period,
    filters.from ?? null,
    filters.to ?? null,
    filters.limit,
  ] as const;
}

export function workflowRunsRequestParams(filters: WorkflowRunsQueryFilters): URLSearchParams {
  const params = new URLSearchParams({
    source: filters.source,
    limit: String(filters.limit),
    period: filters.period,
  });
  filters.workflow.filter(Boolean).forEach((value) => params.append("workflowName", value));
  // Run status values are intentionally sent unchanged. The runs API knows
  // about lifecycle values that history charts may project into broader groups.
  filters.status.filter(Boolean).forEach((value) => params.append("status", value));
  if (filters.from) params.set("from", filters.from);
  if (filters.to) params.set("to", filters.to);
  return params;
}
